import { render, staticRenderFns } from "./DebugMenuHost.vue?vue&type=template&id=2884dab4&scoped=true&"
import script from "./DebugMenuHost.vue?vue&type=script&lang=js&"
export * from "./DebugMenuHost.vue?vue&type=script&lang=js&"
import style0 from "./DebugMenuHost.vue?vue&type=style&index=0&id=2884dab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2884dab4",
  null
  
)

export default component.exports